import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Alert, Button, Col, DatePicker, Form, Input, notification, Radio, Row, Select, Spin } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import debounce from 'lodash/debounce';

import * as leadController from '../../../../../../services/api/lead';
import * as programmeController from '../../../../../../services/api/programme';
import * as channelController from '../../../../../../services/api/channel';
import * as consultantController from '../../../../../../services/api/consultant';
import * as customerController from '../../../../../../services/api/customer';
import { genderOptions, leadTypeOptions, leadSourceOptions, leadStatusOptions, customerQualificationOptions, customerWorkExperienceOptions } from '../../../../../../utils/options';
import './LeadForm.scss';

const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

export class LeadForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            programmes: [],
            channels: [],
            consultants: [],
            customers: [],
            selectedCustomer: {},
            isLoading: false,
            isCustomerLocked: false,
            originalProgrammeId: undefined,
            originalChannelId: undefined
        };

        this.fetchCustomers = debounce(this.fetchCustomers, 500);
    }

    fetchLead(leadId) {
        const { form } = this.props;
        leadController.getLead(leadId)
            .then((res) => res.json())
            .then((json) => {
                const {
                    source,
                    type,
                    interested_programme_id,
                    channel_id,
                    consultant_id,
                    status,
                    customer_id,
                    customer,
                    message,
                    enquiry_date,
                    due_date,
                    last_follow_up_date,
                    next_follow_up_date,
                    last_appointment_date,
                    next_appointment_date,
                    is_enrolled,
                    enrolled_date,
                    remarks,
                    is_potential,
                    is_blacklisted
                } = json;

                if (customer_id !== null)
                    this.fetchCustomer(customer_id);
                form.setFieldsValue({ is_new_customer: _.isUndefined(customer_id) });
                form.setFieldsValue({
                    source,
                    type,
                    interested_programme_id,
                    channel_id,
                    consultant_id,
                    status,
                    customer_id,
                    message,
                    enquiry_date: enquiry_date && moment(enquiry_date),
                    due_date: due_date && moment(due_date),
                    last_follow_up_date: last_follow_up_date && moment(last_follow_up_date),
                    next_follow_up_date: next_follow_up_date && moment(next_follow_up_date),
                    last_appointment_date: last_appointment_date && moment(last_appointment_date),
                    next_appointment_date: next_appointment_date && moment(next_appointment_date),
                    is_enrolled,
                    enrolled_date: enrolled_date && moment(enrolled_date),
                    remarks,
                    is_potential,
                    is_blacklisted
                });

                this.setState({ isCustomerLocked: customer.is_locked, originalProgrammeId: interested_programme_id, originalChannelId: channel_id })
            })
    }

    fetchCustomer(customerId) {
        const { form } = this.props;

        customerController.getCustomer(customerId)
            .then((res) => res.json())
            .then((json) => {
                if (json.error) {
                    form.setFieldsValue({ customer_id: undefined });
                    this.setState({ customers: [], selectedCustomer: {} });
                } else {
                    const { email2, contact_number2, name, gender, company_name, occupation, qualification, work_experience } = json;
                    form.setFieldsValue({ email2, contact_number2, name, gender, company_name, occupation, qualification, work_experience });
                    this.setState({ customers: [json], selectedCustomer: json });
                }
            })
    }

    fetchCustomers(query) {
        if (query !== '')
            customerController.searchCustomers(query)
            .then((res) => res.json())
            .then((json) => this.setState({ customers: json }))
    }

    fetchProgrammes() {
        programmeController.getProgrammes()
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json }))

    }

    fetchChannels() {
        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json }))
    }

    fetcbConsultants() {
        consultantController.getConsultants({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ consultants: json }))
    }

    handleCustomerSearch(value) {
        this.fetchCustomers(value);
    }

    handleSubmit(e) {
        const { history, form, leadId } = this.props;
        const isCreateNewLead = leadId === undefined;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                const { email, contact_number, email2, contact_number2, name, gender, company_name, occupation, qualification, work_experience, is_new_customer, customer_id, ...rest } = values;
                let body = { ...rest };

                if (!is_new_customer)
                    body.customer_id = customer_id;
                body.customer = { email, contact_number, email2, contact_number2, name, gender, company_name, occupation, qualification, work_experience };

                (isCreateNewLead ? leadController.createLead(body) : leadController.updateLead(leadId, body))
                .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        if (isCreateNewLead)
                            history.push(`/dashboard/lead/${json.id}`);
                        else
                            this.fetchLead(leadId);
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        const { form, leadId } = this.props;

        let promises = [];

        this.setState({ isLoading: true });
        promises.push(this.fetchProgrammes());
        promises.push(this.fetchChannels());
        promises.push(this.fetcbConsultants());

        if (leadId === undefined) {
            form.resetFields();
        } else {
            promises.push(this.fetchLead(leadId));
        }

        Promise.all(promises)
            .then(() => this.setState({ isLoading: false }));
    }

    componentDidUpdate(prevProps, prevState) {
        const { form, leadId } = this.props;

        if (leadId !== prevProps.leadId) {
            if (leadId === undefined) {
                form.resetFields();
            } else {
                this.fetchLead(leadId);
            }
        }
    }

    render() {
        const { history, form, userId, isAdmin, leadExpiryDay, leadId } = this.props;
        const { programmes, channels, consultants, customers, selectedCustomer, isLoading, isCustomerLocked, originalChannelId, originalProgrammeId } = this.state;
        const { getFieldDecorator } = form;
        const isCreateNewLead = leadId === undefined;
        const isLocked = !isCreateNewLead && isCustomerLocked;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const customerOptionComponents = _.map(customers, (customer) => 
            <Option key={customer.id} label={customer.name} value={customer.id}>
                <Row>
                    <Col span={24}>
                        {customer.name}
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        {`Email: ${customer.email || 'N/A'}`}
                    </Col>
                    <Col span={12}>
                        {`Contact Number: ${customer.contact_number || 'N/A'}`}
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        {`Email 2: ${customer.email2 || 'N/A'}`}
                    </Col>
                    <Col span={12}>
                        {`Contact Number 2: ${customer.contact_number2 || 'N/A'}`}
                    </Col>
                </Row>
            </Option>);
        const qualificationOptions = _.map(customerQualificationOptions, (option) => <Option key={option} value={option}>{option}</Option>);
        const workExperienceOptions = _.map(customerWorkExperienceOptions, (option) => <Option key={option} value={option}>{option}</Option>);
        const genderOptionComponents = _.map(genderOptions, (genderOption) => <Option key={genderOption} value={genderOption}>{genderOption}</Option>);
        const typeOptionComponents = _.map(leadTypeOptions, (typeOption) => <Option key={typeOption} value={typeOption}>{typeOption}</Option>);
        const sourceOptionComponents = _.map(leadSourceOptions, (sourceOption) => <Option key={sourceOption} value={sourceOption}>{sourceOption}</Option>);
        const statusOptionComponents = _.map(leadStatusOptions, (statusOption) => <Option key={statusOption} value={statusOption}>{statusOption}</Option>);
        const programmeOptionComponents = _.map(_.filter(programmes, (o) => o.is_active || o.id === originalProgrammeId), (programme) =>
            <Option key={programme.id} value={programme.id}>
                {`[${programme.course_code ? programme.course_code.name : 'N/A'}] ${programme.programme_code} - ${programme.name}`}
            </Option>);
        const consultantOptionComponents = _.map(consultants, (consultant) => <Option key={consultant.id} value={consultant.id}>{consultant.name}</Option>);
        const channelOptionComponents = _.map(_.filter(channels, (o) => o.is_active || o.id === originalChannelId), (channel) =>
            <Option key={channel.id} value={channel.id}>
                {`[${channel.type ? channel.type.name : ''}]${channel.name} - ${channel.source ? channel.source.name : ''}`}
            </Option>);
        const lockedMessage = isAdmin ? 'This lead is locked due to duplicate email/contact number of the cusomter. Solve the customer issue to unlock the lead.' : 'This lead is locked due to duplicate email/contact number of the cusomter. Only Admin can modify it.';

        const isEnrolled = form.getFieldValue('is_enrolled');
        const isNewCustomer = form.getFieldValue('is_new_customer');
        // const selectedCustomerId = form.getFieldValue('customer_id');
        // const selectedCustomer = selectedCustomerId && customers.length !== 0 ? (_.find(customers, { id: selectedCustomerId }) || {}) : {};

        return (
            <Spin spinning={isLoading}>
                <Form className="LeadForm" onSubmit={(e) => this.handleSubmit(e)}>
                    {
                        isLocked && 
                        <Row gutter={32}>
                            <Col span={24}>
                                <Alert type="error" message={lockedMessage}/>
                            </Col>
                        </Row>
                    }
                    <Row gutter={32}>
                        <Col span={12}>
                            <h3>Customer Information</h3>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Is New Customer?">
                                {
                                    getFieldDecorator('is_new_customer', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                        initialValue: isCreateNewLead
                                    })(
                                        <RadioGroup disabled={isLocked}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </RadioGroup>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    {
                        !isNewCustomer && 
                        <Row gutter={32}>
                            <Col span={24}>
                                <FormItem 
                                    labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                                    wrapperCol={{ xs: { span: 24 }, sm: { span: 20 } }}
                                    label="Customer"
                                >
                                    {
                                        getFieldDecorator('customer_id', {
                                            rules: [{
                                                required: true,
                                                message: 'This field is required.'
                                            }],
                                        })(
                                            <Select 
                                                showSearch
                                                optionLabelProp="label"
                                                dropdownMatchSelectWidth={false}
                                                placeholder="Type Email or Contact Number to Search Customer..."
                                                onSearch={(value) => this.handleCustomerSearch(value)}
                                                onChange={(value) => this.fetchCustomer(value)}
                                                filterOption={false}
                                                disabled={isLocked}
                                            >
                                                {customerOptionComponents}
                                            </Select>
                                        )
                                    }
                                </FormItem>
                            </Col>
                        </Row>
                    }
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Name">
                                {
                                    getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Input placeholder="Input Customer Name" disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Gender">
                                {
                                    getFieldDecorator('gender')(
                                        <Select placeholder="Select Customer Gender" disabled={isLocked}>
                                            {genderOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Email">
                                {
                                    isNewCustomer ?
                                    getFieldDecorator('email')(
                                        <Input placeholder="Input Customer Email" disabled={isLocked}/>
                                    ) :
                                    selectedCustomer.email
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Contact Number">
                                {
                                    isNewCustomer ?
                                    getFieldDecorator('contact_number')(
                                        <Input placeholder="Input Customer Contact Number" disabled={isLocked}/>
                                    ) :
                                    selectedCustomer.contact_number
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Email 2">
                                {
                                    getFieldDecorator('email2')(
                                        <Input placeholder="Input Customer Email 2" disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Contact Number 2">
                                {
                                    getFieldDecorator('contact_number2')(
                                        <Input placeholder="Input Customer Contact Number 2" disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Company Name">
                                {
                                    getFieldDecorator('company_name')(
                                        <Input placeholder="Input Customer Company Name" disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Occupation">
                                {
                                    getFieldDecorator('occupation')(
                                        <Input placeholder="Input Customer Occupation" disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Qualification">
                                {
                                    getFieldDecorator('qualification')(
                                        <Select placeholder="Select Qualification" disabled={isLocked}>
                                            {qualificationOptions}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Work Experience">
                                {
                                    getFieldDecorator('work_experience')(
                                        <Select placeholder="Select Work Experience" disabled={isLocked}>
                                            {workExperienceOptions}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <h3>Lead Information</h3>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Source">
                                {
                                    getFieldDecorator('source', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Select placeholder="Select Lead Source" disabled={isLocked}>
                                            {sourceOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Type">
                                {
                                    getFieldDecorator('type')(
                                        <Select placeholder="Select Lead Type" disabled={isLocked}>
                                            {typeOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Programme">
                                {
                                    getFieldDecorator('interested_programme_id')(
                                        <Select 
                                            showSearch
                                            dropdownMatchSelectWidth={false}
                                            placeholder="Select Enquiried Programme(if any)"
                                            disabled={isLocked}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {programmeOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Channel">
                                {
                                    getFieldDecorator('channel_id')(
                                        <Select 
                                            showSearch
                                            placeholder="Select Channel of Knowing Us" 
                                            disabled={isLocked}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {channelOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Consultant">
                                {
                                    getFieldDecorator('consultant_id', {
                                        rules: [{
                                            required: false,
                                            message: 'This field is required.'
                                        }],
                                        initialValue: isAdmin ? undefined : userId
                                    })(
                                        <Select disabled={!isAdmin || isLocked} placeholder="Select Consultant">
                                            {consultantOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Status">
                                {
                                    getFieldDecorator('status', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Select placeholder="Select Status" disabled={isLocked}>
                                            {statusOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem 
                                labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                                wrapperCol={{ xs: { span: 24 }, sm: { span: 20 } }}
                                label="Message"
                            >
                                {getFieldDecorator('message')(
                                    <TextArea 
                                        placeholder="Input Customer Message" 
                                        autosize={{ minRows: 3, maxRows: 4 }}
                                        disabled={isLocked}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Enquiry Date">
                                {
                                    getFieldDecorator('enquiry_date', {
                                        initialValue: moment()
                                    })(
                                        <DatePicker disabled={!isAdmin || isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Due Date">
                                {
                                    getFieldDecorator('due_date', {
                                        initialValue: leadExpiryDay ? moment().add(leadExpiryDay, 'days') : undefined
                                    })(
                                        <DatePicker disabled={!isAdmin || isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Last Follow Up">
                                {
                                    getFieldDecorator('last_follow_up_date')(
                                        <DatePicker disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Next Follow Up">
                                {
                                    getFieldDecorator('next_follow_up_date')(
                                        <DatePicker disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Last Appointment">
                                {
                                    getFieldDecorator('last_appointment_date')(
                                        <DatePicker disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Next Appointment">
                                {
                                    getFieldDecorator('next_appointment_date')(
                                        <DatePicker disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Enrolled">
                                {
                                    getFieldDecorator('is_enrolled', {
                                        initialValue: false
                                    })(
                                        <RadioGroup disabled={isLocked}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </RadioGroup>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Enroll Date">
                                {
                                    getFieldDecorator('enrolled_date', {
                                        rules: [{ 
                                            required: isEnrolled,
                                            message: 'Please specify the enroll date.'
                                        }]
                                    })(
                                        <DatePicker disabled={isLocked}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem 
                                labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                                wrapperCol={{ xs: { span: 24 }, sm: { span: 20 } }}
                                label="Remarks"
                            >
                                {getFieldDecorator('remarks')(
                                    <TextArea placeholder="Input Remarks" autosize={{ minRows: 3, maxRows: 4 }} disabled={isLocked}/>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Potential">
                                {
                                    getFieldDecorator('is_potential', {
                                        initialValue: false
                                    })(
                                        <RadioGroup disabled={isLocked}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </RadioGroup>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Black-listed">
                                {
                                    getFieldDecorator('is_blacklisted', {
                                        initialValue: false
                                    })(
                                        <RadioGroup disabled={isLocked}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </RadioGroup>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button onClick={(e) => history.push('/dashboard/lead')}>Back</Button>
                            {' '}
                            <Button type="primary" htmlType="submit" disabled={isLocked}>{isCreateNewLead ? 'Create' : 'Update'}</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.user.id,
    isAdmin: state.user.isAdmin,
    leadExpiryDay: state.config.leadExpiryDay
});

const WrappedLeadForm = Form.create()(LeadForm);
export default connect(mapStateToProps)(withRouter(WrappedLeadForm));


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/LeadManagementPage/components/LeadForm/LeadForm.js